module.exports = __webpack_public_path__ + "media/images/icotype-9ff8696c0c82862ae5072032ae59cc94.svg";